import { TextField } from '@mui/material';

import { createStyles, makeStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import { NextTheme } from '../../../layout/theme-next/provider';

export const selectStyles = makeStyles((theme: NextTheme) =>
  createStyles({
    root: {
      margin: theme.spacing(2.1, 0, 1),
      width: '100%',
    },
    input: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0.3, 0.3, 0.3, 0.3),
    },
  }),
);

export const StyledSearchTextField = withStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(0.6),
  },
}))(TextField);
